export default __webpack_public_path__ + "static/media/icon9.3ba48ea5.svg";